import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    getCumulativeRes: null,
    getMyLabResultsRes: null,
    sendReportRes: null,
};

const slice = createSlice({
    name: 'labReport',
    initialState,
    reducers: {
        getCumulativeReportRequest: (state) => { state.loading = true; },
        getCumulativeReportSuccess: (state, action) => { state.loading = false; state.getCumulativeRes = action.payload; },
        getCumulativeReportFailure: (state, action) => { state.loading = false; state.getCumulativeRes = action.payload; },
        resetGetCumulativeReport: (state) => { state.getCumulativeRes = null; },

        getMyLabResultsRequest: (state) => { state.loading = true; },
        getMyLabResultsSuccess: (state, action) => { state.loading = false; state.getMyLabResultsRes = action.payload; },
        getMyLabResultsFailure: (state, action) => { state.loading = false; state.getMyLabResultsRes = action.payload; },
        resetGetMyLabResults: (state) => { state.getMyLabResultsRes = null; },

        sendLabReportRequest: (state) => { state.loading = true; },
        sendLabReportSuccess: (state, action) => { state.loading = false; state.sendReportRes = action.payload; },
        sendLabReportFailure: (state, action) => { state.loading = false; state.sendReportRes = action.payload; },
        resetSendLabReport: (state) => { state.sendReportRes = null; },
    }
});

export const {
    getCumulativeReportRequest, getCumulativeReportSuccess, getCumulativeReportFailure, resetGetCumulativeReport,
    getMyLabResultsRequest, getMyLabResultsSuccess, getMyLabResultsFailure, resetGetMyLabResults,
    sendLabReportRequest, sendLabReportSuccess, sendLabReportFailure, resetSendLabReport,
} = slice.actions;

export default slice.reducer;
